<template>
  <div>
    <Layout/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarProcedimiento" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarProcedimiento" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditProcedimiento" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdPedidoDet</th>
          <th scope="col">IdPedido</th>
          <th scope="col">IdElemento</th>
          <th scope="col">Observación</th>
          <th scope="col">Estado</th>
          <th scope="col">Elemento</th>
          <th scope="col">Pedido</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pedidodet in datosPaginados" :key="pedidodet.idprocedimiento">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(pedidodet.idProcedimiento)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(pedidodet.idProcedimiento)" title="Editar">edit_square</i></td>
          <td>{{pedidodet.idPedidoDet}}</td>
          <td>{{pedidodet.idPedido}}</td>
          <td>{{pedidodet.idElemento}}</td>
          <td>{{pedidodet.observacion}}</td>
          <td>{{pedidodet.estado}}</td>
          <td>{{pedidodet.elemento}}</td>
          <td>{{pedidodet.pedido}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteProcedimiento(pedidodet.idProcedimiento)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idPedidoDet" class="form-label">IdPedidoDet</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPedidoDet" name="idPedidoDet" v-model="datoPedidoDet.idPedidoDet" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idPedido" name="idPedido" v-model="datoPedidoDet.idPedido"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idPedido" class="form-label"> Pedido</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="pedido" name="pedido" v-model="datoPedidoDet.pedido" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalPedidoLOV"
                      title="Buscar ">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idElemento" name="idElemento" v-model="datoPedidoDet.idElemento"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="elemento" name="elemento" v-model="datoPedidoDet.elemento" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalElementoLOV"
                      title="Buscar ">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoPedidoDet.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarPedidoDet" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPedidoDet" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: PedidoDet -->
    <PedidoDetLOVdet @DatosPedidoDet="GetDataPedidoDetLOVdet($event)"/>
<!-- Lista de Valores: Pedido -->
    <PedidoLOVdet @DatosPedido="GetDataPedidoLOVdet($event)"/>
<!-- Lista de Valores: Elemento -->
    <ElementoLOVdet @DatosElemento="GetDataElementoLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
// Listas de valores master
// Listas de valores details
import PedidoDetLOVdet from '../../components/lovs/PedidoDetLOV.vue'
import PedidoLOVdet from '../../components/lovs/PedidoLOV.vue'
import ElementoLOVdet from '../../components/lovs/PedidoLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, PedidoDetLOVdet
, PedidoLOVdet
, ElementoLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      procedimientos : [],
      datoProcedimiento : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idProcedimiento: '',
// Variables master
// Variables details
      pedidodets : [],
      datoPedidoDet : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idProcedimiento = this.$route.params.p_idprocedimiento
    this.abrirEditar(this.p_idProcedimiento)
    this.getPedidoDets()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      return 1;
    },
    async guardarProcedimiento(){
      if(this.validarForm() === 1){
        try {
          await api.post('/procedimientos', this.datoProcedimiento)
          swal("Correcto!", "Procedimiento creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditProcedimiento(){
      if(this.validarForm() === 1){
        try {
          await api.post('/procedimientos', this.datoProcedimiento)
          swal("Correcto!", "Procedimiento creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoProcedimiento={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idProcedimiento){
      this.modalWindow = true
      if(idProcedimiento != null){    
           api.get('/vwprocedimientos/'+idProcedimiento).then(resp=>{
          this.datoProcedimiento = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarProcedimiento(){
      this.$router.push('/Procedimiento')
    },
// Procedimientos master
// Procedimientos detalle
    async getPedidoDets() {
      const resp = await api.get('/pedidodets')
      this.pedidodets = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.pedidodets.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwpedidodets/nombre/'+this.nombreBusqueda).then(response=>{
          this.pedidodets=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.pedidodets.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwpedidodets').then(response=>{
      this.pedidodets=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.pedidodets.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      return 1;
    },
    async guardarPedidoDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/pedidodets', this.datoPedidoDet)
          this.getPedidoDets();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "PedidoDet creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPedidoDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/pedidodets', this.datoPedidoDet)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "PedidoDet creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoPedidoDet={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idPedidoDet){
      this.modalWindow = true
      if(idPedidoDet != null){    
           api.get('/vwpedidodets/'+idPedidoDet).then(resp=>{
          this.datoPedidoDet = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idPedidoDet){
      this.modalWindow = true
      if(idPedidoDet != null){
        this.$router.push('/pedidodetmd/'+idPedidoDet)
      }
    },
    async deletePedidoDet (idPedidoDet) {
      try{
        await api.delete('/pedidodets/'+idPedidoDet)
          this.getPedidoDets()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataPedidoDetLOVdet(data) {
      this.datoPedidoDet.idPedidoDet = data.idPedidoDet;
      this.datoPedidoDet.pedidoDet = data.nombre;
    },
//    Lista de Valores
    GetDataPedidoLOVdet(data) {
      this.datoPedidoDet.idPedido = data.idPedido;
      this.datoPedidoDet.pedido = data.nombre;
    },
//    Lista de Valores
    GetDataElementoLOVdet(data) {
      this.datoPedidoDet.idElemento = data.idElemento;
      this.datoPedidoDet.elemento = data.nombre;
    },
// Listas de valores details
  },
}
</script>
